import {
  Activity,
  Archive,
  Database,
  Globe,
  LucideIcon,
  Server,
  Zap,
} from "lucide-react";

export function getServiceIcon(type: string): LucideIcon {
  const t = (type || "").toLowerCase();
  if (t.startsWith("database")) return Database;
  if (t === "object-storage") return Archive;
  if (t.startsWith("observability")) return Activity;
  if (t === "worker" || t === "cron" || t === "function") return Zap;
  if (t.startsWith("web")) return Globe;
  return Server;
}

// Services where the connection tab should be visible.
// Derived purely from the type string — no lookup table.
export function isConnectionService(type: string): boolean {
  const t = (type || "").toLowerCase();
  return t.startsWith("database") || t === "object-storage" || t.startsWith("observability");
}
